import { useDispatch } from "react-redux";
import ModalBottom from "../../../../UI/ModalBottom";
import { useEffect, useState } from "react";
import {
  SET_SHOW_BARCHIVE_BOX,
  ADD_BARCHIVE,
  EDIT_BARCHIVE,
} from "../../../../../redux/action/cases/add/type";
import { ReactSVG } from "react-svg";
import {
  ADD_ITEM_BARCHIVE_IN_EDIT_FORM_CASE,
  EDIT_ITEM_BARCHIVE_IN_EDIT_FORM_CASE,
} from "../../../../../redux/action/cases/edit/type";
import Input from "../../../../UI/Input";
import { toast } from "react-toastify";
import { handleNumericInput } from "../../../../../utils/numericInput";

const AddCaseBarchiveModal = ({ showContactsBox, ...props }) => {
  const dispatch = useDispatch();
  const [showingModal, setShowingModal] = useState(false);

  const [newBarchive, setNewBarchive] = useState({
    branch_name: "",
    baygani_code: "",
  });

  useEffect(() => {
    if (showContactsBox) {
      document.body.classList.add("modal-opened");
    }
    if (props.editItemBarchive) {
      setNewBarchive(props.editItemBarchive);
    }
    return () => {
      if (document.body.classList.contains("modal-opened"))
        document.body.classList.remove("modal-opened");
    };
  }, []);

  const setShowModal = (value) => {
    dispatch({
      type: SET_SHOW_BARCHIVE_BOX,
      payload: value,
    });
  };

  const hideModal = () => {
    setShowingModal(false);

    setTimeout(() => {
      dispatch({
        type: SET_SHOW_BARCHIVE_BOX,
        payload: false,
      });
    }, 300);

    document.body.classList.remove("modal-opened");
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0 });
  };

const updateBarchiveField = (e, inputName) => {
  let value = e.target.value;
  if (inputName === "baygani_code") {
    value = handleNumericInput(value);
    if (value.length > 7) {
      toast.error("تعداد کاراکترهای مجاز برای کد بایگانی حداکثر ۷ رقم است!");
      return;
    }
  }
  setNewBarchive({
    ...newBarchive,
    [inputName]: value,
  });
  if (inputName === "baygani_code") {
    e.target.value = value;
  }
};

  const AddBarchiveFieldTostate = (e) => {
    e.preventDefault();

    if (
      newBarchive.baygani_code.length === 0 ||
      newBarchive.branch_name.length === 0
    ) {
      toast.error("وارد کردن شماره بایگانی و نام شعبه الزامی است");
    } else {
      if (props.editItemBarchive) {
        if (props.edit) {
          dispatch({
            type: EDIT_ITEM_BARCHIVE_IN_EDIT_FORM_CASE,
            payload: newBarchive,
          });
        } else {
          dispatch({
            type: EDIT_BARCHIVE,
            payload: newBarchive,
          });
        }

        props.setEditItemBarchive();
      } else {
        if (props.edit) {
          dispatch({
            type: ADD_ITEM_BARCHIVE_IN_EDIT_FORM_CASE,
            payload: newBarchive,
          });
        } else {
          dispatch({
            type: ADD_BARCHIVE,
            payload: { ...newBarchive, id: Math.floor(Math.random() * 1000) },
          });
        }
      }
      hideModal();
    }
  };

  return (
    <ModalBottom
      show={showContactsBox}
      onSetShow={setShowModal}
      className="overflow-y-auto no-scrollbar h-full"
      showing={showingModal}
      onSetShowing={setShowingModal}
    >
      <div className="sticky top-0 left-0 flex flex-col bg-white w-full z-[1] border-b border-b-slate-200">
        <div className="py-2 bg-white z-[1] mb-2">
          <div className="mx-auto w-20 h-2 bg-gray-200 rounded-2xl"></div>
        </div>

        <div className="flex items-center justify-between gap-4 mb-4">
          <button onClick={hideModal} type="button" className="w-10 group">
            <ReactSVG
              src={`${process.env.PUBLIC_URL}/assets/images/icons/back.svg`}
              className="w-5 text-gray-600 hover:text-primary duration-300 rotate-180 mr-1.5 group-disabled:text-gray-400 group-disabled:opacity-70"
            />
          </button>

          <button
            // disabled={
            //   newBarchive.branch_name.length > 3 ||
            //   newBarchive.baygani_code.length !== 7
            // }
            onClick={AddBarchiveFieldTostate}
            className="shadow-custom-sm shadow-primary/10 rounded-lg text-white bg-primary flex items-center justify-center gap-2 profile-btn outline outline-2 outline-primary/10 px-2 py-1"
          >
            ثبت
          </button>
        </div>
      </div>

      <div className="grid xm:grid-cols-2 grid-cols-1 gap-8 mt-5">
        <Input
          id={"branch_name"}
          label={"نام شعبه"}
          icon={"folder"}
          type="text"
          className={"text-right"}
          value={newBarchive.branch_name}
          onChange={(e) => updateBarchiveField(e, "branch_name")}
        />

        <Input
          id={"baygani_code"}
          label={"شماره بایگانی پرونده"}
          max={7}
          icon={"folder"}
          type="tel"
          className={"text-right"}
          value={newBarchive.baygani_code}
          onChange={(e) => updateBarchiveField(e, "baygani_code")}
        />
      </div>
    </ModalBottom>
  );
};

export default AddCaseBarchiveModal;
